import * as React from 'react';
import Svg, {G, Mask, Path, Rect} from 'react-native-svg';
import {memo} from 'react';

interface IProps {
  width?: number;
  height?: number;
}

const CanteenMenuItemBoilerPlate = memo(
  ({width = 110, height = 110}: IProps) => (
    <Svg width={width} height={height} viewBox="0 0 110 110" fill="none">
      <Rect
        opacity="0.95"
        x="0.5"
        y="0.5"
        width="109"
        height="109"
        rx="7.5"
        fill="#003349"
        stroke="#CFCFCF"
      />
      <Mask
        id="mask0_13348_24359"
        maskUnits="userSpaceOnUse"
        x="18"
        y="17"
        width="75"
        height="75"
      >
        <Path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M18 35.7322C18 25.3867 26.3851 17 36.7322 17H74.2678C84.6133 17 93 25.3851 93 35.7322V73.2678C93 83.6133 84.6149 92 74.2678 92H36.7322C26.3867 92 18 83.6149 18 73.2678V35.7322Z"
          fill="white"
        />
      </Mask>
      <G mask="url(#mask0_13348_24359)">
        <Path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M50.9139 44.0018C51.5445 43.525 52.226 43.1067 52.9511 42.7519L47.4521 32.2017C45.9653 32.9312 44.5568 33.7946 43.2422 34.775L50.9139 44.0018Z"
          fill="#A5CF4F"
        />
        <Path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M49.459 31.317L54.0799 42.2663C54.8971 41.9594 55.7608 41.7291 56.6631 41.5816L54.2273 29.9507C52.5825 30.2563 50.9881 30.7176 49.459 31.317Z"
          fill="#A5CF4F"
        />
        <Path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M63.4343 29.7725L61.7441 41.6511C62.6104 41.8198 63.4461 42.07 64.2471 42.3918L68.4725 31.0323C66.8626 30.4298 65.1873 30.0158 63.4343 29.7725Z"
          fill="#A5CF4F"
        />
        <Path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M76.1919 35.8028C74.3413 34.1365 72.421 32.8399 70.4044 31.8613L65.2959 42.8648C66.2629 43.349 67.172 43.9416 68.0146 44.6313L76.1919 35.8028Z"
          fill="#A5CF4F"
        />
        <Path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M68.6342 63.1303C66.4236 65.5156 63.0245 67.2698 59.5521 67.4241C52.1434 67.7553 46.3254 62.2968 45.9896 54.9928C45.7968 50.8054 47.3533 47.1776 50.0441 44.7232L41.5683 36.1294C36.0854 40.9548 32.674 47.957 33.0247 55.5717C33.7062 70.4083 45.0481 79.9663 60.0975 79.294C66.8097 78.994 73.1675 75.9644 77.5771 70.9647L68.6342 63.1303Z"
          fill="#A5CF4F"
        />
        <Path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M57.8786 41.4355C58.0372 41.4237 58.1958 41.41 58.3562 41.4032C59.1074 41.3696 59.8412 41.3963 60.5576 41.4735L61.2584 29.5582C60.1409 29.4916 58.9955 29.4804 57.8108 29.5339C57.3308 29.5551 56.8551 29.5924 56.3818 29.6403L57.8786 41.4355Z"
          fill="#A5CF4F"
        />
      </G>
    </Svg>
  ),
);
export default CanteenMenuItemBoilerPlate;
